import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import {
  FaWhatsapp,
  FaFacebookF,
  FaLinkedin,
  FaInstagram,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { TbPhoneCall } from "react-icons/tb";
import { GiOfficeChair } from "react-icons/gi";
import { HiOutlineDevicePhoneMobile } from "react-icons/hi2";

const ContactInfo = () => {
  const [contactData, setContactData] = useState(null);
  const [loading, setLoading] = useState(true); // to handle loading
  const [error, setError] = useState(null);     // to handle errors

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const docRef = doc(db, "contactInfo", "eLEZFK77BPlj1ftNcTRc"); // your document ID
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setContactData(docSnap.data());
        } else {
          setError("No contact info found!");
        }
      } catch (err) {
        setError("Error fetching contact info!");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchContactInfo();
  }, []);

  // Format landline number to +92 (533) 728 469
  const formatLandline = (phone) => {
    if (!phone) return "";
    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length === 10) {
      return `+92 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)} ${cleaned.slice(6)}`;
    }
    if (cleaned.length === 11) {
      return `+92 (${cleaned.slice(2, 5)}) ${cleaned.slice(5, 8)} ${cleaned.slice(8)}`;
    }
    if (cleaned.length === 12 && cleaned.startsWith("92")) {
      return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 5)}) ${cleaned.slice(5, 8)} ${cleaned.slice(8)}`;
    }
    return phone;
  };

  // Format mobile number
  const formatMobile = (phone) => {
    if (!phone) return "";
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length === 12 && cleaned.startsWith("92")) {
      return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 5)}) ${cleaned.slice(5, 8)} ${cleaned.slice(8)}`;
    }
    if (cleaned.length === 11 && cleaned.startsWith("3")) {
      return `+92 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)} ${cleaned.slice(6)}`;
    }
    return phone;
  };

  if (loading) return <p>Loading contact info...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="contact-info-section padding-container">
      <div className="page-cover">
        <div className="Grid-3-box">
          {/* Contact Us */}
          <div className="contact-us">
            <div
              className="calling"
              style={{ backgroundImage: "url('/assets/Images/Calling-bro.png')" }}
            ></div>
            <h1>Contact US</h1>
            <a
              href={`tel:${contactData["phone one"]}`}
              style={{ textDecoration: "none", color: "var(--black-color)" }}
            >
              <div className="land-number">
                <TbPhoneCall style={{ fontSize: "24px", color: "#FF8000", margin: "10px" }} />
                <p>{formatLandline(contactData["phone one"])}</p>
              </div>
            </a>
            <a href={`tel:${contactData["phone two"]}`}
              style={{ textDecoration: "none", color: "var(--black-color)" }}
            >
              <div className="land-number">
                <HiOutlineDevicePhoneMobile style={{ fontSize: "24px", color: "#FF8000", margin: "10px" }} />
                <p>{formatMobile(contactData["phone two"])}</p>
              </div>
            </a>
            <p className="call-timing">
              (Call will be answered during these hours: <br />
              {contactData["office timings"]} <br />
              Other than these hours we'll not be able to reply you)
            </p>
          </div>

          {/* General Inquiry */}
          <div className="contact-us">
            <div
              className="calling"
              style={{ backgroundImage: "url('/assets/Images/Messages-pana.png')" }}
            ></div>
            <h1>General Inquiry</h1>
            {["first email", "second email", "third email", "fourth email"].map(
              (emailKey, index) =>
                contactData[emailKey] && (
                  <div className="land-number" key={index}>
                    <img src="/assets/Images/E-mail.png" alt="" />
                    <p>{contactData[emailKey].trim()}</p>
                  </div>
                )
            )}
          </div>

          {/* Our Location */}
          <div className="contact-us">
            <div
              className="calling"
              style={{ backgroundImage: "url('/assets/Images/Paper map-cuate.png')" }}
            ></div>
            <h1>Our Location</h1>
            <div className="land-location">
              <img src="/assets/Images/Subtract (3).png" alt="" />
              <p>{contactData.address}</p>
            </div>
            <div className="land-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3040.4271878641966!2d74.06477688110996!3d32.58965079226945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391f1ad2ec5c194b%3A0x3e141a53d0c02f1d!2sVisionBird%20Technologies%20(Software%20House)!5e0!3m2!1sen!2s!4v1754692118482!5m2!1sen!2s"
                width="600"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="VisionBird Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;